import { render, staticRenderFns } from "./OutdatedEstimations.vue?vue&type=template&id=519215bb&"
import script from "./OutdatedEstimations.vue?vue&type=script&lang=js&"
export * from "./OutdatedEstimations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports